import { Pipe, PipeTransform } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'formatTitle' })
export class FormatTitlePipe implements PipeTransform {
  transform(value: string): SafeHtml {
    return value.replace(/\[\d{2}-\d{3,4}]/g, '');
  }
}
